import { DatePicker, type DateValue } from '@ark-ui/react/date-picker';
import type React from 'react';
import { useCalendarStyling } from '../hooks/useCalendarStyling';

interface CalendarCellProps {
  day: DateValue;
  isToday: boolean;
  isSelected: boolean;
  isWeekend: boolean;
  isCurrentMonth: boolean;
  isHovered: boolean;
  status: string;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  isHoliday: boolean;
  isPast: boolean;
  actualHours: number;
  projectHours: number;
  isAbsence: boolean;
  isVacation: boolean;
  isBridge: boolean;
}

export const CalendarCell: React.FC<CalendarCellProps> = ({
  day,
  isToday,
  isSelected,
  isWeekend,
  isCurrentMonth,
  isHovered,
  status,
  onMouseEnter,
  onMouseLeave,
  isHoliday,
  isPast,
  actualHours,
  projectHours,
  isAbsence,
  isVacation,
  isBridge,
}) => {
  const isApproved = status === 'approved';
  const isDraft = status === 'draft';
  const isNotLogged = status === 'NotLogged';

  const { cellStyles, statusIndicatorStyles, todayIndicatorStyles, textStyles } =
    useCalendarStyling({
      isSelected,
      isHovered,
      isCurrentMonth,
      isWeekend,
      isToday,
      isApproved,
      isDraft,
      isNotLogged,
      isHoliday,
      isPast,
      actualHours,
      projectHours,
      isAbsence,
      isVacation,
      isBridge,
    });

  return (
    <DatePicker.TableCell value={day}>
      <DatePicker.TableCellTrigger
        style={cellStyles}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          {/* Status indicator circle - don't show for holidays */}
          {!isWeekend && isCurrentMonth && !isHoliday && <div style={statusIndicatorStyles} />}

          {/* Today indicator - always show underline for today */}
          {isCurrentMonth && isToday && <div style={todayIndicatorStyles} />}

          {/* Date number */}
          <span style={textStyles}>{isCurrentMonth ? day.day : ''}</span>
        </div>
      </DatePicker.TableCellTrigger>
    </DatePicker.TableCell>
  );
};
